import React, { useEffect, useState } from "react";

import { getDaysArr, getMonthArr, getYearArr } from "./helper";

import styles from "./DatePicker.module.scss";
import Button from "@Components/Button";
import ScrollableOptionsList from "../ScrollableOptionSelector";
import BottomSheetOverlay from "@Components/BottomSheetOverlay";
import useIsDesktop from "hooks/useIsDesktop";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import useWhitelabel from "hooks/useWhitelabel";

interface Props {
  day: string;
  month: string;
  year: string;
  maxYear?: string;
  handleSelectDate: ({
    dayState,
    monthState,
    yearState,
  }: {
    dayState: string;
    monthState: string;
    yearState: string;
  }) => void;
  minYear?: string;
  hideDatePicker: () => void;
  isAboveMD?: boolean;
}
const DatePicker: React.FC<Props> = (props) => {
  const {
    day,
    month,
    year,
    maxYear,
    minYear,
    handleSelectDate,
    hideDatePicker,
    isAboveMD = true,
  } = props;
  const isDesktop = useIsDesktop() && isAboveMD;
  const { t } = useTranslationHook();
  const { isWhitelabel } = useWhitelabel();
  const [dayState, setDayState] = useState(day);
  const [monthState, setMonthState] = useState(month);
  const [yearState, setYearState] = useState(year);
  const daysArr = getDaysArr(monthState, yearState, maxYear, minYear);
  const monthsArr = getMonthArr(minYear, maxYear, yearState).map((...args) => args[1]);
  const yearArr = getYearArr(maxYear, minYear).reverse();

  const onClickHandler = (e: any): void => {
    e.preventDefault();
    handleSelectDate({
      dayState,
      monthState:
        Number(yearState) === Number(minYear)
          ? 12 - getMonthArr(minYear, maxYear, yearState).length + monthState + 1
          : monthState + 1,
      yearState,
    });
  };

  useEffect(() => {
    if (maxYear && year > maxYear) setYearState(maxYear);
    else setYearState(year);
  }, [maxYear]);

  const render = () => (
    <div className={styles.container}>
      <div className={styles.contentSection}>
        <ScrollableOptionsList
          options={daysArr}
          selectedValue={Number(dayState)}
          onChange={(dayValue) => setDayState(dayValue)}
        />
        <ScrollableOptionsList
          options={monthsArr}
          selectedValue={Number(monthState)}
          onChange={(monthValue) => setMonthState(monthValue)}
          labelModifier={(monthIndex) => getMonthArr(minYear, maxYear, yearState)[monthIndex]}
        />
        <ScrollableOptionsList
          options={yearArr}
          selectedValue={Number(yearState)}
          noInifinite
          onChange={(yearValue) => setYearState(yearValue)}
        />
      </div>
      <div className={styles.btnWrapper}>
        <Button
          onClick={onClickHandler}
          size="medium"
          variant={isWhitelabel ? "whiteLabel_primary" : "primary"}
          dataTestId="done-button"
        >
          {t("Done")}
        </Button>
      </div>
    </div>
  );

  return isDesktop ? (
    render()
  ) : (
    <BottomSheetOverlay hideBottomSheetOverlay={hideDatePicker}>{render()}</BottomSheetOverlay>
  );
};

DatePicker.defaultProps = {
  maxYear: "",
  minYear: "",
};

export default wrapperHOC(DatePicker, {
  componentName: "DatePicker-Global",
  showForChina: true,
});
